import { useState, useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { BLUR_COMMAND, FOCUS_COMMAND } from "lexical";

const COMMAND_PRIORITY_LOW = 1;

const useEditorFocus = () => {
	const [editor] = useLexicalComposerContext();
	// Possibly use useRef for synchronous updates but no re-rendering effect
	const [hasFocus, setFocus] = useState<boolean>(false);

	useEffect(
		() =>
			editor?.registerCommand(
				BLUR_COMMAND,
				() => {
					setFocus(false);

					return false;
				},
				COMMAND_PRIORITY_LOW,
			),
		[editor],
	);

	useEffect(
		() =>
			editor?.registerCommand(
				FOCUS_COMMAND,
				() => {
					setFocus(true);
					return false;
				},
				COMMAND_PRIORITY_LOW,
			),
		[editor],
	);

	return hasFocus;
};

export default useEditorFocus;
